export default {
  staged: 'Staged',
  published: 'Published',
  deleted: 'Deleted',
  received: 'Received',
};
